module.exports = __webpack_public_path__ + "media/promo/advent/images/logom-2-9036d996b64173691b415cc78d5fed07.png";